// PWA utility functions

// Check if PWA is installable
export const isPWAInstallable = () => {
  return 'serviceWorker' in navigator && 'BeforeInstallPromptEvent' in window;
};

// Check if app is already installed
export const isPWAInstalled = () => {
  // Check if running in standalone mode (iOS)
  if (window.matchMedia('(display-mode: standalone)').matches) {
    return true;
  }
  
  // Check if running in standalone mode (Android)
  if (window.navigator.standalone === true) {
    return true;
  }
  
  // Check if app is installed via manifest
  if (document.referrer.includes('android-app://')) {
    return true;
  }
  
  return false;
};

// Register service worker
export const registerServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then((registration) => {
          console.log('Service Worker registered successfully:', registration.scope);
          
          // Check for updates
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  // New service worker available
                  console.log('New service worker available');
                  // You can show a notification to the user here
                }
              });
            }
          });
        })
        .catch((error) => {
          console.log('Service Worker registration failed:', error);
        });
    });
  }
};

// Unregister service worker (for development)
export const unregisterServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister();
    });
  }
};

// Check if app is online
export const isOnline = () => {
  return navigator.onLine;
};

// Listen for online/offline events
export const setupOnlineStatusListener = (onOnline, onOffline) => {
  window.addEventListener('online', () => {
    console.log('App is online');
    if (onOnline) onOnline();
  });
  
  window.addEventListener('offline', () => {
    console.log('App is offline');
    if (onOffline) onOffline();
  });
};

